import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Send httpOnly cookies with every request
});

// Token is stored in sessionStorage (scoped to the browser tab — not persistent across
// browser restarts like localStorage, and safer against stored XSS).
// The httpOnly cookie is the authoritative session; sessionStorage is only used so that
// the WebSocket can reconnect after a page refresh within the same tab.

export const setInMemoryToken = (token) => {
  if (token) sessionStorage.setItem('_t', token);
  else sessionStorage.removeItem('_t');
};

export const clearInMemoryToken = () => {
  sessionStorage.removeItem('_t');
};

export const getInMemoryToken = () => sessionStorage.getItem('_t');

api.interceptors.request.use(
  (config) => {
    const token = getInMemoryToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Auth endpoints that legitimately return 401 (bad credentials, etc.).
// Redirecting to /login on those would remount the page and wipe the form.
const AUTH_401_NO_REDIRECT = [
  '/auth/login',
  '/auth/register',
  '/auth/forgot-password',
  '/auth/reset-password',
  '/auth/activate',
];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const skipRedirect = AUTH_401_NO_REDIRECT.some((path) =>
        requestUrl.includes(path)
      );
      if (!skipRedirect) {
        clearInMemoryToken();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
